import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { Card } from "primereact/card";
import { SpeedDial } from "primereact/speeddial";
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { Toast } from 'primereact/toast';
import { ScrollPanel } from 'primereact/scrollpanel';

const DailyCalendar = ({ customerId }) => {

  const [classSchedule, setClassSchedule] = useState([]);
  const menuLeft = useRef(null);
  const menuRight = useRef(null);

  const toast = useRef(null);

let items = [
    {label: 'New', icon: 'pi pi-fw pi-plus'},
    {label: 'Delete', icon: 'pi pi-fw pi-trash'}
];


  const header = (
    <div className="flex flex-wrap align-items-center justify-content-between gap-2">
    <span className="text-xl text-900 font-bold">Time Table</span>
    <Button icon="pi pi-plus" rounded outlined aria-label="Filter" />
    </div>
  );

  const statusBodyTemplate = (rowData) => {
    return (
      <Tag value={rowData.status} severity={getSeverity(rowData.status)} />
    );
  };

  const getSeverity = (status) => {
    switch (status) {
      case "cancelled":
        return "danger";

      case "ongoing":
        return "success";

      case "done":
        return "info";

      case "future":
        return "warning";

      case "renewal":
        return null;
    }
  };

  return (
        <DataTable
          header={header}
          value={classSchedule}
          rowGroupMode="rowspan"
          groupRowsBy="class.name"
          sortMode="single"
          sortField="class.name"
          sortOrder={1}
          tableStyle={{ minWidth: "50rem" }}
          emptyMessage = "No timetable set"
        >
          <Column
            header="#"
            headerStyle={{ width: "3rem" }}
            body={(data, options) => options.rowIndex + 1}
          ></Column>
          <Column
            field="representative.name"
            header="Class"
            style={{ minWidth: "200px" }}
          ></Column>
          <Column
            field="Monday"
            header="Monday"
            style={{ minWidth: "200px" }}
          ></Column>
          <Column
            field="Tuesday"
            header="Tuesday"
            style={{ minWidth: "200px" }}
          ></Column>
          <Column
            field="Wednesday"
            header="Wednesday"
            style={{ minWidth: "200px" }}
          ></Column>
          <Column
            field="Thursday"
            header="Thursday"
            style={{ minWidth: "200px" }}
          ></Column>
          <Column
            field="Friday"
            header="Friday"
            style={{ minWidth: "200px" }}
          ></Column>
          <Column
            field="status"
            header="Status"
            body={statusBodyTemplate}
            style={{ minWidth: "100px" }}
          ></Column>
          <Column
            field="date"
            header="Date"
            style={{ minWidth: "100px" }}
          ></Column>
        </DataTable>
  );
};

export default DailyCalendar;
